import pl from 'date-fns/locale/pl';
import ru from 'date-fns/locale/ru';
import uk from 'date-fns/locale/uk';
import bg from 'date-fns/locale/bg';
import pt from 'date-fns/locale/pt';
import ro from 'date-fns/locale/ro';
import kk from 'date-fns/locale/kk';
import uz from 'date-fns/locale/uz';
import en from 'date-fns/locale/en-US';

export type LanguageTag =
    | 'bg-BG'
    | 'ro-RO'
    | 'pl-PL'
    | 'ru-KZ'
    | 'kk-KZ'
    | 'pt-PT'
    | 'uk-UA'
    | 'ru-UA'
    | 'uz-UZ'
    | 'ru-UZ'
    | 'en_US';

export const languageData: Record<LanguageTag, Locale> = {
    'pl-PL': pl,
    'ru-UA': ru,
    'uk-UA': uk,
    'bg-BG': bg,
    'ro-RO': ro,
    'pt-PT': pt,
    'ru-KZ': ru,
    'kk-KZ': kk,
    'ru-UZ': ru,
    'uz-UZ': uz,
    en_US: en
};
